import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ItemMemberLevel } from "sprout-graphql";
import { useMemo } from "react";
import { Page } from "@sprout/client-layout";
import Head from "@sprout/client-layout/dist/Head";
import { TopicPageProvider } from "../TopicPageContext";
import TopicPageViewsLabelsMain from "./TopicPageViewsLabelsMain";
import TopicPageViewsLabelsNew from "./TopicPageViewsLabelsNew";
import TopicPageViewsLabelsAppBarMobile from "./TopicPageViewsLabelsAppBarMobile";
const TopicPageViewsLabelsPage = (props)=>{
    const { topic  } = props;
    const { deletedAt , archivedAt , memberLevel  } = topic;
    const contextValue = useMemo(()=>{
        return {
            isOwner: memberLevel === ItemMemberLevel.Owner,
            isOwnerOrAdmin: memberLevel ? [
                ItemMemberLevel.Owner,
                ItemMemberLevel.Admin
            ].includes(memberLevel) : false,
            isPartOfTopic: memberLevel ? ![
                ItemMemberLevel.Invited,
                ItemMemberLevel.Pending
            ].includes(memberLevel) : false,
            disabled: deletedAt !== null || archivedAt !== null
        };
    }, [
        archivedAt,
        deletedAt,
        memberLevel
    ]);
    const isLabelEnabled = contextValue.isOwnerOrAdmin && !contextValue.disabled;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                title: `All ${topic.title} Labels | Sprout`
            }),
            /*#__PURE__*/ _jsx(TopicPageProvider, {
                value: contextValue,
                children: /*#__PURE__*/ _jsxs(Page, {
                    variant: "shadow",
                    appBar: isLabelEnabled ? /*#__PURE__*/ _jsx(TopicPageViewsLabelsNew, {
                        rootTopicId: topic.id
                    }) : undefined,
                    children: [
                        isLabelEnabled && /*#__PURE__*/ _jsx(TopicPageViewsLabelsAppBarMobile, {
                            rootTopicId: topic.id
                        }),
                        /*#__PURE__*/ _jsx(TopicPageViewsLabelsMain, {
                            topic: topic
                        })
                    ]
                })
            })
        ]
    });
};
export default TopicPageViewsLabelsPage;
